import type { SupWeb3Address, SupWeb3Balance } from "@/types";
import { useMemo } from "react";

import useChainContractConfig from "@/hooks/data/useChainContractConfig";
import useERC20Allowance from "@/hooks/web3/useERC20Allowance";

export default function useERC20SuperRouterAllowance(selectedBalance: SupWeb3Balance | undefined, watch: boolean = false, contractAddress: SupWeb3Address | undefined = undefined) {
  const contractConfig = useChainContractConfig(selectedBalance);
  const address = useMemo(() => contractAddress || contractConfig?.address, [contractAddress, contractConfig?.address]);

  return useERC20Allowance(watch, selectedBalance?.address, address, selectedBalance?.chainId);
}
